/* eslint-disable react-hooks/exhaustive-deps */
import {
  ActionCardProps,
  ActionsProps,
  Product,
  RightPanelTabs,
  RightPanelTabsConfiguration,
} from '@access-erp/common';
import { CardType, IRowNode } from '@access-erp/ui-components';
import { useMemo, useState } from 'react';

import { CustomerOutput } from '@/graphql/contracts/_generated_/contracts';
import { browserHistory } from '@/routing/browserHistory';
import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';
import { contractsBCPath } from '@/utils/path.utlis';

type ActionButton = {
  config: ActionCardProps;
  isVisible: boolean;
};

interface UseRightPanelParams {
  selectedHeaderRows: IRowNode<CustomerOutput>[];
}

export function useRightPanel({ selectedHeaderRows }: UseRightPanelParams) {
  const [isVisibleParentModal, setIsVisibleParentModal] = useState(false);
  const actionButtons = useMemo<ActionButton[]>(
    () => [
      {
        config: {
          text: 'All Contracts',
          cardType: CardType.LINK,
          product: Product.ContractsAndBilling,
          onClick: async () => {
            const customerSearchParams =
              `customerAccountNumber=${selectedHeaderRows[0]?.data?.customerAccountNumber ?? ''}`;

            const link = `/${contractsBCPath}/customers?${customerSearchParams}`;
            browserHistory.push(getParameterizedLink(link));
          },
        },
        isVisible: selectedHeaderRows.length > 0,
      },
    ],
    [selectedHeaderRows],
  );

  const actionsParams: ActionsProps = {
    actionCards: {
      actions: actionButtons.filter((el) => el.isVisible).map((el) => el.config),
    },
  };

  const tabsConfiguration = useMemo<RightPanelTabsConfiguration>(
    () => ({
      [RightPanelTabs.ACTIONS]: actionsParams,
    }),
    [selectedHeaderRows],
  );

  return {
    tabsConfiguration,
    isVisibleParentModal,
    closeParentModal: () => setIsVisibleParentModal(false),
  };
}
